import { render, staticRenderFns } from "./locationDrawer.vue?vue&type=template&id=22245f5c&scoped=true"
import script from "./locationDrawer.vue?vue&type=script&lang=js"
export * from "./locationDrawer.vue?vue&type=script&lang=js"
import style0 from "./locationDrawer.vue?vue&type=style&index=0&id=22245f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22245f5c",
  null
  
)

export default component.exports